export default "__VITE_ASSET__CZHRKrAk__"